import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent, PropsWithChildren, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import styles from './GenericModal.module.scss';

interface GenericModalProps extends PropsWithChildren {
    footer: ReactNode;
    className?: string;
    zIndex?: number;
    fullScreen?: boolean;
    onClose?: () => void;
}

const GenericModal: FunctionComponent<GenericModalProps> = props => {
    return createPortal(
        <div
            className={clsx(styles.overlay, props.fullScreen && styles.overlayFullScreen)}
            style={props.zIndex !== undefined ? { zIndex: props.zIndex } : undefined}
        >
            <div className={clsx(styles.modal, props.fullScreen && styles.modalFullScreen, props.className)}>
                <div className={styles.header}>
                    <FontAwesomeIcon
                        icon={faTimes}
                        fontSize={18}
                        onClick={props.onClose}
                        className={styles.closeIcon}
                    />
                </div>
                <div className={clsx(styles.body, props.fullScreen && styles.bodyFullScreen)}>{props.children}</div>
                <div className={styles.footer}>{props.footer}</div>
            </div>
        </div>,
        document.body
    );
};

export default GenericModal;
